module.exports = __webpack_public_path__ + "static/media/1.453c7973.jpg";